import React from 'react';

import EditorFormType from '../formItem/EditorFormType';
import ArgCallerType from '../formItem/ArgCallerType';
import ArgCaller from '../formItem/ArgCaller';
import FormLookup from '../components/FormLookup';
import FormLookupServerAllSpec from '../components/FormLookupServerAllSpec';
import FormLookupServerSpec from '../components/FormLookupServerSpec';
import FormModuleLookup from '../components/FormModuleLookup';
import FormLookupFixed from '../components/FormLookupFixed';
import FormItemUtil from './FormItemUtil';
import GOT from './GOT';
import GOTUtil from './GOTUtil';
import Warn from './Warn';
import AjaxRemoteUtil from './AjaxRemoteUtil';
import GOTXML2Json from '../remote/GOTXML2Json';
import Command from '../remote/Command';
import ServiceHelper from '../remote/ServiceHelper';
import FormItemConst from '../formItem/FormItemConst';
export default class FormLookupFactory
{
	
	static mapFormLookup = {};
	static mapHasFormLookup = {};
	static formLookupXMLTemplate ={
		FormDataSources:{qname: "FormDataSources", name: "DataSources",Properties:{DefaultQuery:{Value:""}},
			DataSources:[
			{
				name:"",id:"3",Properties:
				{
					Table:{Value:""},FetchAll:{Value:false},DefaultOrderBy:{Value:""},
					Reverse:{Value:false},StartPosition:{Value:"First"},InsertAt:{Value:"First"},
					OnlyFetchActive:{Value:false},JoinSource:{Value:""},JoinType:{Value:"Delayed"},
					DelayActive:{Value:true},AllowQuery:{Value:true},AllowExport:{Value:true},
					AllowEdit:{Value:true},AllowAdd:{Value:true},AllowDelete:{Value:true},
					AllowAttachment:{Value:false},ExternalJoin:{Value:true}
				},FormDataSourceFields:[],FormDataSourceFieldGroups:[],FormDataSourceRelation:[]
			}]
		},
		Properties:{Design:{Value:true}},
		id:"",
		name:"",
		nextInnerId:"4",
		qname:"Form",
	};
	
	static clearFormLookupCache(entityid)
	{
		if(entityid == null)
		{
			mapFormLookup = {};
			mapHasFormLookup = {};
		}
		else
		{
			var temp = [];
			for(let key in FormLookupFactory.mapFormLookup)
			{
				if(key.split(".")[0] == entityid)
				{
					temp.push(key);
				}
			}
			
			for(let i in temp)
			{
				let key = temp[i];
				mapFormLookup[key] = null;
				delete mapFormLookup[key];
			}
			
			temp.splice(0,temp.length);
			for(let key in FormLookupFactory.mapHasFormLookup)
			{
				if(key.split(".")[0] == entityid)
				{
					temp.push(key);
				}
			}
			
			for(let i in temp)
			{
				let key = temp[i];
				mapHasFormLookup[key] = null;
				delete mapHasFormLookup[key];
			}
		}
	}
	
	static hasFormLookup(base, ownerEntityId, ownerGroup)
	{
		if(!ownerEntityId)
			return false;
		
		var key = FormLookupFactory.getKey(base);
		if(key==null)
			return false;
		
		var result;
		
		////TODO 去取beforeInit缓存下来的内容，如果二次开发指定了 那么就按照二次开发指定的 而不再执行原来逻辑
		////由于从时序上 权限以及GOT allowEdit的设定是在前面  所以这么做的优先级顺序是 权限或者allowEdit属性设置-->二次开发-->GOT树
		
		if(this.mapHasFormLookup.hasOwnProperty(key))
		{
			result = this.mapHasFormLookup[key];
		}
		else
		{
			result = FormLookupFactory.getResult(base);
			this.mapHasFormLookup[key] = result;
		}
		
		if(result==null)
		{
			return false;
		}
		else
		{
			var ownerForm = GOT.getForm(ownerEntityId);
			if(ownerForm==null)
			{
				return true;
			}
			else
			{
				var ownerFormName = ownerForm.name;
			}
			
			
			var lookupFormName;
			if(typeof(result) == "object")
			{
				var dataTypeRelation = result.DataTypeRelation;
				var mainTablePro = dataTypeRelation.Properties["Table"];
				var _mainTable = GOT.getTable(mainTablePro.refentityid);
				
				if(base.hasOwnProperty("refentityid"))
				{
					if(base["refentityid"]==mainTablePro.refentityid)
					{
						if(base.hasOwnProperty("refinnerid"))
						{
							if(base["refinnerid"]==FormLookupFactory.getMainFieldId(dataTypeRelation))
								return false;
						}
					}
				}
				return true;
			}
			else if(typeof(result) == "string")
			{
				if(result == "isEnum" || result == "isBoolean" || result == "isServerSpecify")
					return true;
				if(base.hasOwnProperty("refentityid") && base.hasOwnProperty("refinnerid"))
				{
					var _table = GOT.getTable(base["refentityid"]);
					if(_table != null)
					{
						var _tableField = GOT.getTableField(_table,base["refinnerid"]);
						if(_tableField != null)
						{
							var extendsPro = _tableField.Properties["Extends"];
							if(extendsPro.hasOwnProperty("refentityid"))
							{
								var _dataType = GOT.getDataType(extendsPro.refentityid);
								if(_dataType != null)
								{
									var _dataTypeType = _dataType.type;
									if(_dataTypeType == "String")
									{
										var _relation = _dataType.DataTypeRelation;
										if(_relation != null)
										{
											var _mainForm2;
											if(_relation.Properties.hasOwnProperty(FormItemConst.PROPERTY_MAINFORM_NAME))
												_mainForm2 = _relation.Properties[FormItemConst.PROPERTY_MAINFORM_NAME].V;
											else
												_mainForm2 = _relation.Properties[FormItemConst.PROPERTY_MAINFORM_NAME2].V
											var _mainFieldId = FormLookupFactory.getMainFieldId(_relation);
										}
									}
									else if(_dataTypeType == "Component")
									{
										var componentItemName = base["componentItemName"];
										var dataTypeArrayItem = GOT.getDataTypeArrayItem(_dataType,componentItemName);
										if(dataTypeArrayItem != null)
										{
											extendsPro = dataTypeArrayItem.Properties["RefDataType"];
											if(extendsPro.hasOwnProperty("refentityid"))
											{
												_dataType = GOT.getDataType(extendsPro.refentityid);
												if(_dataType != null)
												{
													_relation = _dataType.DataTypeRelation;
													if(_relation != null)
													{
														if(_relation.Properties.hasOwnProperty(FormItemConst.PROPERTY_MAINFORM_NAME))
															_mainForm2 = _relation.Properties[FormItemConst.PROPERTY_MAINFORM_NAME].V;
														else
															_mainForm2 = _relation.Properties[FormItemConst.PROPERTY_MAINFORM_NAME2].V
														//_mainForm2 = _relation.Properties["MainForm"].V;
														_mainFieldId = FormLookupFactory.getMainFieldId(_relation);
													}
												}
											}
										}
									}
								}
							}
						}
						
						if(_mainForm2 == ownerFormName && base["refinnerid"] == _mainFieldId)
						{
							return false;
						}
					}
				}

				return true;
				
			}
			
			return true;
		}
					
	}
	
	static getMainFieldId(dataTypeRelation)
	{
		var dataTypeRelationItem = GOT.getDataTypeRelationNormalItem(dataTypeRelation);
		
		var fieldPro = dataTypeRelationItem.Properties["Field"];
		if(!fieldPro.hasOwnProperty("refentityid"))
		{
			throw new Error("GOT错误 the Field Pro of DataTypeRelationItem is null");
		}
		return fieldPro.refinnerid;
	}
	
	static getKey(base)
	{
		if(base==null)
			return null;
		
		var key;
		
		var assignedLookupName = base["assignedLookup"];
		if(assignedLookupName==null || assignedLookupName=="" || assignedLookupName == "isEnum" || assignedLookupName == "isServerSpecify")
		{
			key = base["entityId"] + "." + base["innerId"] + "." + base["componentItemName"];
		}
		else
		{
			key = assignedLookupName;
		}
		
		return key;
	}
	
	
	static getResult(base)
	{
		var result;
		
		var assignedLookupName = base["assignedLookup"];
		
		/*if(assignedLookupName && typeof(assignedLookupName) == "object")
			return null;*/

		if(assignedLookupName == "isBoolean" || assignedLookupName == "isEnum")
		{
			return assignedLookupName;
		}
		
		if(!assignedLookupName)
		{
			result = FormLookupFactory.getLookupFormStepByStep(
				GOTUtil.getDataType2(base["entityId"], base["innerId"]),base["formType"], 
				base["componentItemName"]);
			
			if(typeof(result) == "string")
			{
				assignedLookupName = result;
			}
		}
		
	
		while(assignedLookupName!=null && assignedLookupName.indexOf("dt:")==0)
		{
			try
			{
				var dataType = GOTUtil.getDataType2(assignedLookupName.substring(3),null);
				
			}
			catch(e)
			{
				// var event:EditorErrorMessageEvent = new EditorErrorMessageEvent(EditorErrorMessageEvent.MESSAGETYPE,true);
				// event.info = "建议检查FormLookup属性是否填写正确";
				// event.messageType = EditorMessageType.ERROR;
				// GongqiERP.getSingleton().dispatchEvent(event);
				assignedLookupName = null;
				break;
			}
			result = GOTUtil.getLookupFormStepByStep(dataType,null);
			if(typeof(result) == "string")
				assignedLookupName = result;
			else
				assignedLookupName = null;
		}
		
		if(assignedLookupName!=null && assignedLookupName!="")
		{
			if(!assignedLookupName.indexOf("lookup:")==0)
			{
				result = "gongqi/erp/layers/sys/forms/"+ assignedLookupName +".swf";
			}
			else
			{
				result = "gongqi/erp/layers/sys/lookup/" + assignedLookupName.substring(7) + ".swf";
			}
			
		}
		
		return result;
	}
	
	static createFormLookup(base,pop)
	{
		var key = FormLookupFactory.getKey(base);
		if(key==null)
			return;
		
		var result;
		if(FormLookupFactory.mapFormLookup.hasOwnProperty(key))
		{
			//alert("返回缓存");
			return FormLookupFactory.mapFormLookup[key];
		}
		
		//var isQueryForm = (base["formType"] == EditorFormType.QueryForm);

		if(FormLookupFactory.mapHasFormLookup.hasOwnProperty(key))
		{
			result = FormLookupFactory.mapHasFormLookup[key];				
		}
		else
		{
			result = FormLookupFactory.getResult(base);
			FormLookupFactory.mapHasFormLookup[key] = result;
		}

		// if(window.isDataSetView){
		// 	// let tableField = GOT.getTableFieldById(base,base);
		// 	let itemdataType = GOT.getDataType(base.extends.refentityid);
		// 	result = itemdataType;
		// }
		
		
		if(!result)
		{
			//后台指定
			if(!base["formLookup"])
				return null;
			return <FormLookupServerAllSpec entityId={base["entityId"]} innerId={base["innerId"]} 
					lookupKey={key} groupAlias={base["groupAlias"]} fieldName={base["fieldName"]}
					remoteArg={base["formLookup"]} minWidth={base["minWidth"]}/>;
		}
		else if(typeof(result) == "object")
		{
			var argCaller = new ArgCaller();
			argCaller.type = ArgCallerType.StringEditor;
			var lookUp;
			if(base["formLookup"])
			{
				//lookUp = new FormLookupServerSpec(result as XML,formLookup);
				lookUp = <FormLookupServerSpec dataType={result} argCaller={argCaller} lookupAlias={"FormLookup"} 
							entityId={base["entityId"]} innerId={base["innerId"]} lookupKey={key} isPop={base["isPop"]}
							formLookupRemote={base["formLookup"]}/>;
			}
			else
			{
				lookUp = <FormLookup formType={base["formType"]} dataType={result} argCaller={argCaller} lookupAlias={"FormLookup"} 
							entityId={base["entityId"]} innerId={base["innerId"]} lookupKey={key} isPop={base["isPop"]}/>;
			}
			if(base["formType"]==EditorFormType.QueryForm)
				lookUp.lookupForQuery = true;
			
			
			if(!FormLookupFactory.mapFormLookup.hasOwnProperty(key))
			{
				FormLookupFactory.mapFormLookup[key] = lookUp;
			}
			return lookUp;
		}
		else if(typeof(result) == "string")
		{
			if(result == "isBoolean")
			{
				var lookUpFixed = <FormLookupFixed dataProvider={[{label:"是",value:"true"},{label:"否",value:"false"}]}
									lookupForQuery={true} returnField={"value"}/>;
				
				FormLookupFactory.mapFormLookup[key] = lookUpFixed;
				
				return lookUpFixed;
			}
			else if(result == "isServerSpecify")
			{
				var lookupserverspecify = <FormLookupServerSpecify />;
				FormLookupFactory.mapFormLookup[key] = lookupserverspecify;				
				return lookupserverspecify;
			}
			else if(result == "isEnum")
			{
				var entityId = base["entityId"];
				var innerId = base["innerId"];
				var property = GOTUtil.getItemPropertyFinalValue(entityId,innerId);
				if(property.hasOwnProperty("DataProvider"))
				{
					lookUpFixed = <FormLookupFixed lookupForQuery={true} dataProvider={property.DataProvider}/>;
					/*var providerHeight = property.DataProvider.length * 25 + 50;
					var fixedHeight = providerHeight > 300?300:providerHeight;
					lookUpFixed.dataProvider = property.DataProvider;*/
				}
				else
				{
					throw new Error("property dont has property DataProvider");
				}
				
				FormLookupFactory.mapFormLookup[key] = lookUpFixed;
				return lookUpFixed;
			}
			else
			{
				var url = result ;
				//"gongqi/erp/layers/sys/forms/gongqi.erp.baseform.LookUp_ProjectLine.swf"
				var formName;
				if(url.indexOf(".swf") != -1)
					formName = url.substring(url.lastIndexOf("/")+1,url.indexOf(".swf"));
				else
					formName = url;
				//还是采用在同一window域下存在多个form
				//return {isCustom:true,formName:formName};

				var formXML = GOT.getForm(formName);
				if(formXML == null)
				{
					var command = Command.createService( "gongqi.erp.gotmodel.services.GOTService", "loadFormWhole", "FormWholeObject");
					command.appendArg(null);command.appendArg(formName);command.appendArg(null);command.appendArg(null);command.appendArg(null);command.appendArg(null);
					command.appendArg(null, "java.util.Map");
					let result = null;
					var _resultHandler = function(data)
					{
						var xmlDoc = GOTXML2Json.getXMLDoc(data.result.formObjectStandard.formXML);
			      		var formXML = GOTXML2Json.parseForm(xmlDoc);
				  
				        //window.formXML = formXML;
				        GOT.setForm(formXML);
				        var _key = FormItemUtil.getFormStoresKey("FormLookup",formXML.id);
				      	window.parent.window[_key] = 
				      	{
				            mapItemProperty:data.result.formObjectStandard.mapItemProperty,
				            listRemoteMethods:data.result.formObjectStandard.listRemoteMethods,
				            listTmpTable:data.result.formObjectStandard.listTmpTable,
							listAggregateTable:data.result.formObjectStandard.listAggregateTable,
							mapQueryTable:data.result.formObjectStandard.mapQueryTable
				        };
				        let formPrefetchCommandResult = data.result.formPrefetchCommandResult;
				        if(formPrefetchCommandResult && formPrefetchCommandResult.commandResults)
				        {
				          let listRemoteMethods = window.parent.window[_key].listRemoteMethods;
				          if(listRemoteMethods)
				          {
				            for(let i = 0;i<listRemoteMethods.length;i++)
				            {
				              let remoteMethod = listRemoteMethods[i];
				              if(formPrefetchCommandResult.commandResults.hasOwnProperty(remoteMethod.methodName))
				              {
				                remoteMethod.commandResult = formPrefetchCommandResult.commandResults[remoteMethod.methodName];
				              }
				            }  
				          }
				        }
				        let argCaller = new ArgCaller();
						argCaller.type = "StringEditor";
						argCaller.calleruuId = window.formModuleInstanceuuId;
						argCaller.callerMenuItemId = window.menuItemId;
						argCaller.callerFormId = window.formId;
						argCaller.callerDataField = base["editorDataField"];
						argCaller.callerKey = base["entityId"];					
				        result = <FormModuleLookup argCaller={argCaller} isPop={base["isPop"]} entityId={base["entityId"]} innerId={base["innerId"]} xml={formXML} formId={formXML.id} menuItemId={"FormLookup"} />;
					};
					var _faultHandler = function(data)
					{
						var faultString;
						if(data && data.successButNot0)
						{
							faultString = data.errText;
						}
						else
						{
							faultString = "可能是网络错误 请检查网络是否正常";
						}
						Warn.show({text:faultString,title:"未能正确打开下拉框"})
					};
					var remoteArg = {command:command,resultFunction:_resultHandler,faultFunction:_faultHandler};
					ServiceHelper.addTokenWithCommand(remoteArg);
					return result;
				}
				else
				{
					let argCaller = new ArgCaller();
					argCaller.type = "StringEditor";
					argCaller.calleruuId = window.formModuleInstanceuuId;
					argCaller.callerMenuItemId = window.menuItemId;
					argCaller.callerFormId = window.formId;
					argCaller.callerDataField = base["editorDataField"];
					argCaller.callerKey = base["entityId"];
					return <FormModuleLookup argCaller={argCaller} isPop={base["isPop"]} entityId={base["entityId"]} innerId={base["innerId"]} xml={formXML} formId={formXML.id} menuItemId={"FormLookup"} />;
				}
			}
		}
	}
	
	
	static getLookupFormStepByStep(dataType, formType,componentItemName)
	{	
		if(dataType == null)
			return null;
		
		if(formType == "FormModule"
			|| formType == "Query")
		{
			var formLookupProValue = GOTUtil.getPropertyValue(dataType,"FormLookup");
			if(formLookupProValue)
			{
				return formLookupProValue;
			}
		}
		
		if(dataType.type=="Component")
		{
			if(componentItemName != null && componentItemName != undefined)
			{
				var componentItemList = dataType.DataTypeArrayItems;
				for(var i in componentItemList)
				{
					var componentItem = componentItemList[i];
					if(componentItem.name == componentItemName)
					{
						return FormLookupFactory.getLookupFormStepByStep(GOTUtil.getDataType2(componentItem.Properties.RefDataType.refentityid,null),formType);
					}
				}
				return null;
			}
			else
			{
				return null;
			}
		}
		else
		{
			var dataTypeRelation = dataType.DataTypeRelation;
			if(dataTypeRelation)
				var mainTablePro = dataTypeRelation.Properties.Table;
			if(mainTablePro && mainTablePro.hasOwnProperty("refentityid"))
			{
				return dataType;
			}
			else
			{
				var ex = dataType.Properties.Extends;
				if(ex.hasOwnProperty("refentityid"))
				{
					return FormLookupFactory.getLookupFormStepByStep(GOTUtil.getDataType2(ex.refentityid, null),formType);
				}
				else
				{
					return null;
				}
			}
		}
		
	}

}



// WEBPACK FOOTER //
// ./src/utils/FormLookupFactory.js